import { Container, Heading, Stack, useToast } from '@chakra-ui/react'
import { AxiosError } from 'axios'
import { useState } from 'react'

import { Section } from '../../components/Section'
import { PageContent } from '../../containers/PageContent'
import { PageToolbar } from '../../containers/PageToolbar'
import { RtpcFilter, rtpcFilterContext } from '../../containers/rtpc/RtpcFilter'
import { RtpcListForm } from '../../containers/rtpc/RtpcListForm'
import { Rtpc } from '../../dtos/rtpc/Rtpc'
import { RtpcQuery } from '../../dtos/rtpc/RtpcQuery'
import { useDeleteRtpc, useSaveRtpc, useSearchRtpc } from '../../hooks/useRtpc'

export const RtpcPage = () => {
  const toast = useToast()
  const [filter, setFilter] = useState<RtpcQuery>({
    onlyValid: true,
    showDeleted: false,
  } as RtpcQuery)
  const { data, isLoading, refetch } = useSearchRtpc(filter)
  const { mutateAsync: saveAsync } = useSaveRtpc()
  const { mutateAsync: deleteAsync } = useDeleteRtpc()

  const saveRtpc = (e: { items: Rtpc[] }) =>
    saveAsync(e.items)
      .then((res) => {
        toast({
          title: 'Uloženo',
          status: 'success',
        })
        refetch()
      })
      .catch((err: AxiosError) => {
        toast({
          title: 'Chyba při ukládání',
          description: `${err.response?.status}: ${err.response?.statusText}`,
          status: 'error',
        })
      })

  const deleteRtpc = (rtpc: Rtpc) =>
    rtpc.rtpcId
      ? deleteAsync(rtpc.rtpcId)
          .then(() => {
            toast({
              title: 'Smazáno',
              status: 'success',
            })
          })
          .catch((e: AxiosError) => {
            toast({
              title: 'Chyba při mazání',
              description: `${e.response?.status}: ${e.response?.statusText}`,
              status: 'error',
            })
          })
      : Promise.resolve()

  return (
    <Section>
      <Container>
        <PageContent>
          <PageToolbar
            leftElements={
              <Heading as="h1">
                Správa RTPC (Real Time Price Correction)
              </Heading>
            }
          />
          <rtpcFilterContext.Provider value={filter}>
            <Stack gap={4}>
              <RtpcFilter onSubmit={setFilter} />
              <RtpcListForm
                items={data?.data || []}
                isLoading={isLoading}
                onSubmit={saveRtpc}
                onDeleteItem={deleteRtpc}
              />
            </Stack>
          </rtpcFilterContext.Provider>
        </PageContent>
      </Container>
    </Section>
  )
}
